import { render, staticRenderFns } from "./DataTableDx.vue?vue&type=template&id=30d8f1a2&scoped=true"
import script from "./DataTableDx.vue?vue&type=script&lang=js"
export * from "./DataTableDx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d8f1a2",
  null
  
)

export default component.exports